import { FlipCardProps } from 'ui/flip-card'

import { Card } from '~/db/types'
import type { CardsFrontUnion } from '~/stores/settings'

export const getFrontBack = (card: Pick<Card, 'learnText' | 'sourceText'>, settingsFront?: CardsFrontUnion) =>
  ({
    front: settingsFront === 'learn' ? card.learnText.trim() : card.sourceText.trim(),
    back: settingsFront === 'learn' ? card.sourceText.trim() : card.learnText.trim(),
  }) satisfies FlipCardProps
